import { map } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { mediaType as MediaType } from '@bt-react/constants'
import { PlayInStatus } from '../../../../lib/playIn/types'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { Observable } from 'rxjs'
import { playInActions } from '../../../slices/playIn'
import { forceLocalMute, forceLocalMuteDisable } from '../../../actions/tracks/trackActions'

const forceLocalMute$ = (actions$: Observable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  //@ts-ignore
  ofType(roomTypes.SET_MEDIA_TYPE_STATE, playInActions.setStatus.type),
  map((action): boolean => {

    const { type, payload } = action

    switch (type) {



      case roomTypes.SET_MEDIA_TYPE_STATE:



        return payload === MediaType.PLAY_IN &&

          state$.value.playIn.status === PlayInStatus.PLAYING ||

          payload === MediaType.EVENT_STREAM



      case playInActions.setStatus.type:



        return payload === PlayInStatus.PLAYING



      default:



        return false



    }

  }),
  map(forceMute => forceMute ? forceLocalMute() : forceLocalMuteDisable())
)

export default forceLocalMute$
